import mixpanel from "mixpanel-browser/src/loaders/loader-module-core";
import { pickBy } from "./nativeLodash";

const MIXPANEL_EU_API_HOST = "https://api-eu.mixpanel.com";

mixpanel.init(import.meta.env.VITE_MIXPANEL_PROJECT_TOKEN, {
  api_host: MIXPANEL_EU_API_HOST,
});

const canTrack = import.meta.env.VITE_MIXPANEL_ACTIVE;

const removeNullProperties = (props?: Record<any, any>) => pickBy(props);

export const Mixpanel = {
  formatAmountForTracking: (amount: number) => {
    const formattedAmount = new Intl.NumberFormat("en-GB", {
      style: "decimal",
    }).format(amount / 100);

    return Number(formattedAmount);
  },
  getDistinctId: (): string => {
    return mixpanel.get_distinct_id();
  },
  identify: (id: string) => {
    if (canTrack) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (canTrack) mixpanel.alias(id);
  },
  track: (name: string, props?: Record<any, any>) => {
    if (canTrack) mixpanel.track(name, removeNullProperties(props));
  },
  reset: () => {
    if (canTrack) mixpanel.reset();
  },
  people: {
    trackCharge: (amount: number, currency: string) => {
      if (canTrack) {
        mixpanel.people.track_charge(amount, {
          original_currency: currency,
        });
      }
    },
    increment: (property: string, value: number) => {
      if (canTrack) {
        mixpanel.people.increment(property, value);
      }
    },
    setOnce: (props: Record<any, any>) => {
      if (canTrack) mixpanel.people.set(removeNullProperties(props));
    },
    set: (props: Record<any, any>) => {
      if (canTrack) mixpanel.people.set(removeNullProperties(props));
    },
    setProp: (key: string, value: string) => {
      if (canTrack) mixpanel.people.set(key, value);
    },
  },
  groups: {
    setGroup: (businessId: number | string) => {
      if (canTrack) {
        mixpanel.set_group("businessId", businessId);
      }
    },
    resetGroup: (businessId: number | string) => {
      if (canTrack) {
        mixpanel.remove_group("businessId", businessId);
      }
    },
    set: (businessId: string | number, props: Record<any, any>) => {
      if (canTrack) {
        mixpanel
          .get_group("businessId", businessId.toString())
          .set(removeNullProperties(props));
      }
    },
    setOnce: (businessId: string | number, props: Record<any, any>) => {
      if (canTrack) {
        mixpanel
          .get_group("businessId", businessId.toString())
          .set_once(removeNullProperties(props));
      }
    },
  },
};
